var map = {
	"./app/children/shared/locales/it.json": "2ca1",
	"./app/courseCategories/shared/locales/it.json": "75ad",
	"./app/courseTypes/shared/locales/it.json": "a26b",
	"./app/courses/shared/locales/it.json": "5481",
	"./app/dashboard/shared/locales/it.json": "1f79",
	"./app/emailLogs/shared/locales/it.json": "c57a",
	"./app/frontends/shared/locales/it.json": "b649",
	"./app/locations/shared/locales/it.json": "db8c",
	"./app/options/shared/locales/it.json": "1559",
	"./app/people/shared/locales/it.json": "fd5f",
	"./app/peopleCourseWeekRegistrations/shared/locales/it.json": "a411",
	"./app/roles/locales/it.json": "3eee",
	"./app/users/locales/it.json": "e409",
	"./locales/it.json": "0825"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80b2";